export default {
  type: '-',
  tags: {id: 0, type: '-', iconName: '', text: ''},
  note: '',
  amount: 0,
  createdAt: ''
};